import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X, Check, ArrowDown, Sparkles } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['Sientes que no sabes por dónde empezar', 'Pasas horas en redes sin generar ingresos', 'Tienes ideas pero nunca las ejecutas', 'Te da miedo invertir y perder dinero', 'Ves a otros avanzar mientras tú sigues igual'];
  const after = ['Tienes un plan claro paso a paso para generar ingresos', 'Usas la IA como tu herramienta secreta de productividad', 'Creas contenido y productos digitales con confianza', 'Generas ingresos sin necesidad de grandes inversiones', 'Tomas acción todos los días con mentalidad ganadora'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0d0b14] relative overflow-hidden" data-id="element-2">
      {/* Decorative Background Blurs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-3">
        <div className="absolute top-1/4 -left-64 w-96 h-96 bg-red-900/20 rounded-full blur-[120px]" data-id="element-4"></div>
        <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-pink-600/20 rounded-full blur-[120px]" data-id="element-5"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-6">
        {/* Header Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-7">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-purple-400 to-pink-400 mb-6 leading-tight pb-2" data-id="element-8">
            ¿Vas a seguir igual... o vas a decidir cambiar tu vida HOY?
          </h2>
          <p className="text-xl sm:text-2xl text-slate-400 font-medium max-w-3xl mx-auto" data-id="element-9">
            Esto es lo que separa a quienes solo sueñan de quienes{' '}
            <span className="text-pink-400 font-bold" data-id="element-10">toman acción</span>.
          </p>
        </motion.div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-12 items-center" data-id="element-11">
          {/* BEFORE Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-red-950/10 backdrop-blur-md rounded-3xl p-8 sm:p-10 border border-red-500/20 shadow-2xl relative overflow-hidden h-full" data-id="element-12">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-13"></div>

            <div className="text-center mb-10 relative z-10" data-id="element-14">
              <span className="inline-block px-4 py-1.5 rounded-full bg-red-500/10 text-red-400 font-bold text-sm tracking-wider mb-4 border border-red-500/20" data-id="element-15">
                EL CAMINO DEL ESTANCAMIENTO
              </span>
              <h3 className="text-3xl font-bold text-slate-300" data-id="element-16">ANTES</h3>
            </div>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-6 relative z-10" data-id="element-17">
              {before.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-4" data-id="element-18">
                  <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0 mt-1 border border-red-500/30" data-id="element-19">
                    <X className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-20" />
                  </div>
                  <span className="text-lg text-slate-400 leading-relaxed" data-id="element-21">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* VS Divider (Desktop) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="hidden lg:flex flex-col items-center justify-center z-20" data-id="element-22">
            <div className="w-16 h-16 rounded-full bg-[#0d0b14] border-2 border-slate-800 flex items-center justify-center shadow-2xl relative" data-id="element-23">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-pink-500/20 to-purple-500/20 blur-md" data-id="element-24"></div>
              <span className="text-xl font-black text-slate-500 italic relative z-10" data-id="element-25">
                VS
              </span>
            </div>
          </motion.div>

          {/* AFTER Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="group bg-gradient-to-br from-pink-500/15 via-purple-500/10 to-pink-500/15 backdrop-blur-md rounded-3xl p-8 sm:p-10 border border-pink-500/30 shadow-[0_0_40px_rgba(236,72,153,0.15)] hover:shadow-[0_0_60px_rgba(236,72,153,0.25)] transition-shadow duration-500 relative overflow-hidden h-full" data-id="element-26">
            {/* Animated Glow */}
            <motion.div animate={{
            opacity: [0.4, 0.7, 0.4],
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute top-0 right-0 w-64 h-64 bg-pink-500/20 rounded-full blur-[80px] -mr-20 -mt-20 pointer-events-none" data-id="element-27"></motion.div>

            <div className="text-center mb-10 relative z-10" data-id="element-28">
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold text-sm tracking-wider mb-4 shadow-lg shadow-pink-500/25" data-id="element-29">
                <Sparkles className="w-4 h-4" data-id="element-30" />
                LA TRANSFORMACIÓN
              </span>
              <h3 className="text-3xl font-bold text-white drop-shadow-md" data-id="element-31">
                DESPUÉS
              </h3>
            </div>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-6 relative z-10" data-id="element-32">
              {after.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-4" data-id="element-33">
                  <div className="w-8 h-8 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-1 border border-emerald-500/40 shadow-[0_0_15px_rgba(16,185,129,0.3)]" data-id="element-34">
                    <Check className="w-5 h-5 text-emerald-400" strokeWidth={3} data-id="element-35" />
                  </div>
                  <span className="text-lg font-medium text-slate-200 leading-relaxed" data-id="element-36">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>

        {/* Bottom CTA Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="mt-20 text-center flex flex-col items-center" data-id="element-37">
          <p className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-38">
            ¿De qué lado quieres estar?
          </p>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center border border-white/10" data-id="element-39">
            <ArrowDown className="w-6 h-6 text-pink-400" data-id="element-40" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}